import { CheckIcon, Clipboard } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';

type CopyToClipboardProps = {
	textToCopy: string;
};

const CopyToClipboard = (props: CopyToClipboardProps) => {
	const { textToCopy } = props;
	const [isCopied, setIsCopied] = useState(false);

	const handleCopyClick = async () => {
		try {
			await navigator.clipboard.writeText(textToCopy);
			setIsCopied(true);
			setTimeout(() => setIsCopied(false), 2000);
		} catch {
			toast.error('Failed to copy text');
		}
	};
	return (
		<div
			title="Copy to clipboard"
			className="flex items-center justify-center cursor-pointer rounded-md h-6 w-6 hover:bg-slate-200 dark:hover:bg-slate-700 [&_svg]:h-3 [&_svg]:w-3"
			onClick={handleCopyClick}
		>
			{isCopied ? <CheckIcon data-testid="check-icon" /> : <Clipboard data-testid="clipboard-icon" />}
		</div>
	);
};

export default CopyToClipboard;
